export const config = {
  URL: "https://innometric.guru",
  //URL: "http://10.90.138.244",
  PORT_NUMBER: "9091",
  OAUTH_PORT: "9094",
  API: {
    VERSION: "V1",
    LOGIN: "login",
    USER: "user",
    USERS: "Users",
    LOGOUT: "logout",
    PROJECT: "project",
    ACTIVITY: "activity",
    PROCESS: "process",
    REGISTER: "User",
    REPORTS: "Reports",
    ACTIVITIES_REPORT: "activitiesReport",
    TIME_REPORT: "timeReport",
    CUMUL_REPORT: "cumulativeReport",
    CATEGORY_REPORT: "categorytimeReport",
    PROJECTS: "projects",
    AGENT_GATEWAY: "AgentGateway",
    AGENT_CONFIG: "AgentConfiguration",
    CONNECT_PROJECT: "ConnectProject",
    OAUTH: "OAuth",
    OAUTH20: "OAuth20",
    PROJECT_DATA: "projectData",
    PROJECT_LIST: "projectList",
    PERMISSION_FOR_USER: "Admin/User/Permissions",
    AGENT_ADMIN: "AgentAdmin",
    AGENT: "Agent",
    METHOD: "AgentConfigMethods",
    DETAILS: "AgentDetails",
    RESPONSE: "AgentResponse",
    AUTH_REST: "V1/Admin",
    COMPANY: "Company",
    AGENTSXCOMPANY: "AgentsCompany",
    EXTERNALPROJECTXTEAM: "ExternalProjectTeam",
    TEAM: "Team",
    TEAM_MEMBER: "Teammember",
    ALL: "all",
    GET_PROJECT: "Project"
  },

  GQM: {
    URL: "http://localhost",
    PORT: "8080",
    API: "api",
    METRICS: "metrics",
    GOALS: "goals",
    QUESTIONS: "questions",
    ASSIGN_METRICS: "assign-metrics"
  },

  CONTENT_TYPES: {
    APPLICATION_JSON: "application/json",
    MULTIPART: "multipart/form-data",
  },

  REQ_TYPES: {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  },
};